import React from "react";
import "../styles/PickupPointList.css";

// Pour afficher les jours en français
const dayNames = {
  "0": "Dimanche",
  "1": "Lundi",
  "2": "Mardi",
  "3": "Mercredi",
  "4": "Jeudi",
  "5": "Vendredi",
  "6": "Samedi"
};

const PickupPointList = ({ points, onSelect }) => {
  return (
    <div className="pickup-point-list">
      {points.length > 0 ? (
        points.map((point) => (
          <div
            key={point.id}
            className="pickup-point-item"
            onClick={() => {onSelect(point)}}
          >
            <h4>{point.name}</h4>
            <p>
              {point.street} {point.house_number}, {point.postal_code} {point.city}
            </p>
            <p>Distance : {point.distance} m</p>
            <div className="opening-times">
              <p>Horaires d'ouverture :</p>
              <ul>
                {Object.keys(point.formatted_opening_times).map((day) => {
                  const times = point.formatted_opening_times[day];
                  return times && times.length > 0 ? (
                    <li key={day}>
                      {dayNames[day]} : {times.join(", ")}
                    </li>
                  ) : null;
                })}
              </ul>
            </div>
          </div>
        ))
      ) : (
        <p>Aucun point relais trouvé.</p>
      )}
    </div>
  );
};

export default PickupPointList;
